export default __webpack_public_path__ + "static/media/cross.1d0e80c6.svg";